export enum Service {
  Templates = 'Assets:Templates',
}
